import React from 'react';
import Header from './components/Header';
import Router from './components/Router';

const App: React.FC = () => {
  return (
    <>
      <Header />
      <Router />
    </>
    );
}

export default App;
